import { t } from "../services/utils";
const appFilesGenStatus = {
  NOT_GENERATED: 1,
  ERROR: 2,
  SUCCESS: 3,
  WAITING_FOR_TFA_CODE: 4,
  REGENERATE: 5,
  GENERATING: 6
};
export default appFilesGenStatus;